document.addEventListener("DOMContentLoaded", function(e){
    document.addEventListener("click", function(e){
        if(e.target.closest("header .header__heading-link")){
            e.preventDefault();
            window.location.reload();
        }
    })
})

/* Mobile sticky CTA refinements (Christina, 2026-07-28). Mirrors /pages/whydm01.

   1. The bar retires once the visitor reaches the end of the page — when either the
      bottom-most CTA or the footer is on screen — so they never see two competing
      buttons at once.
   2b. The bar's bottom padding is raised from 14px to 18px plus the iPhone safe-area
      inset, so it is not clipped by the home indicator (the inset does the real work).
   2. Because the bar can no longer be up while the footer is visible, the footer no
      longer needs lifting clear of it. sections/sticky-cta-whyhj.liquid adds
      `padding-bottom: 130px !important` for that purpose, which now just leaves a long
      empty strip under the last footer link. Trimmed to 34px here.

   Done in this file rather than in the sticky section because this file already loads
   only on whyhj-lp (via its custom-code section), so the change cannot reach another
   page and the section itself stays untouched. An important inline style is the only
   thing that can outrank the section's own !important rule.

   Everything lives in ONE listener so there is a single owner of the bar's inline
   transform — two observers writing the same property fight each other. */
document.addEventListener("DOMContentLoaded", function () {
  var bar = document.querySelector(".sticky-cta-whyhj");
  var footer = document.querySelector("#shopify-section-footer .footer");
  if (!bar || !footer) return;

  var isMobile = function () { return window.matchMedia("(max-width: 767px)").matches; };

  function applyMobileFixes() {
    if (isMobile()) {
      footer.style.setProperty("padding-bottom", "34px", "important");
      /* 3. The bar's own bottom padding is 14px in sections/sticky-cta-whyhj.liquid, which
         leaves it partly under the iPhone home indicator. Raised to 18px (Christina) plus
         the safe-area inset — the theme's viewport meta already sets viewport-fit=cover, so
         env() resolves; it is 0 where there is no inset, leaving exactly 18px. Set with an
         important inline style because the section's rule is ID-scoped. */
      bar.style.setProperty("padding-bottom", "calc(18px + env(safe-area-inset-bottom, 0px))", "important");
    } else {
      footer.style.removeProperty("padding-bottom");
      bar.style.removeProperty("padding-bottom");
    }
  }
  applyMobileFixes();
  window.addEventListener("resize", applyMobileFixes, { passive: true });

  if (!("IntersectionObserver" in window)) return;

  var buttons = document.querySelectorAll(".single-tab__button");
  var ends = [buttons.length ? buttons[buttons.length - 1] : null, footer].filter(Boolean);
  var visible = new WeakSet();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
    });
    var atEnd = ends.some(function (n) { return visible.has(n); });
    // The section's own scroll handler owns the .is-visible class; this inline style
    // overrides it while the visitor is at the end, and is removed to hand control back.
    if (atEnd) bar.style.transform = "translateY(130%)";
    else bar.style.removeProperty("transform");
  }, { threshold: 0.01 });

  ends.forEach(function (n) { io.observe(n); });
});
